/**
 * URL関連のutility
 */
export default class UrlUtility {




  /**
   * 外部呼出し不可
   */
  private constructor() { }




  /**
   * URL文字列のクエリストリングをオブジェクト化して返却します
   *
   * @param url
   * @return クエリストリングをオブジェクト化したもの
   */
  public static getQueryStringObject(url: string): {[key: string]: string} {
    const result: {[key: string]: string} = {};
    const delimiterIndex = url.indexOf('?');
    if (delimiterIndex === -1) return result;
    const keyValues = url.substring(delimiterIndex + 1).split('&');
    keyValues.forEach(kv => {
      const devided = kv.split('=');
      result[devided[0]] = devided[1];
    });
    return result;
  }




}
